module.exports = __webpack_public_path__ + "static/media/MIAB9867-180730-123_Small.52d77740.jpg";